import React, { useState, useEffect } from 'react';
import { WrappedCard } from '../WrappedCard';
import { WrappedImage } from '../WrappedImage';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';

interface OldBalanceCardProps {
  onTimerComplete?: () => void;
  navigationRef?: React.RefObject<any>;
  username?: string;
}

export const OldBalanceCard: React.FC<OldBalanceCardProps> = ({
  username,
}) => {
  const TIMER_DURATION = 8; // 8 seconds countdown
  const [timeRemaining, setTimeRemaining] = useState(TIMER_DURATION);
  const [isComplete, setIsComplete] = useState(false);

  // Start countdown timer (visual only - actual timing controlled by slide duration)
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        const newTime = prev - 1;
        
        if (newTime <= 0) {
          clearInterval(interval);
          setIsComplete(true);
          return 0;
        }
        
        return newTime;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Stop propagation on the card content to prevent navigation handlers from intercepting
  const handleCardClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
  };

  return (
    <a 
      href="https://wingo320.com/old-balance" 
      target="_blank" 
      rel="noopener noreferrer"
      data-no-navigate="true"
      onClick={(e) => {
        console.log('[DIAG] OldBalanceCard link onClick fired');
        e.stopPropagation();
        // Ensure link works
        window.open('https://wingo320.com/old-balance', '_blank', 'noopener,noreferrer');
      }}
      onTouchStart={(e) => {
        console.log('[DIAG] OldBalanceCard link onTouchStart fired');
        e.stopPropagation();
      }}
      onTouchEnd={(e) => {
        console.log('[DIAG] OldBalanceCard link onTouchEnd fired');
        e.stopPropagation();
        // On mobile, ensure link works on touch
        window.open('https://wingo320.com/old-balance', '_blank', 'noopener,noreferrer');
      }}
      onTouchMove={(e) => {
        console.log('[DIAG] OldBalanceCard link onTouchMove fired');
      }}
      className="block w-full h-full cursor-pointer hover:opacity-95 transition-opacity relative"
      style={{ 
        minHeight: '100%', 
        position: 'relative', 
        zIndex: 50, 
        pointerEvents: 'auto',
        touchAction: 'manipulation'
      }}
    >
      <WrappedCard className="bg-black text-white" username={username}>
        <div className="space-y-3 md:space-y-4 group" onClick={handleCardClick} onTouchStart={handleCardClick}>
          <div className="flex justify-center mb-2 relative">
            <div className="absolute inset-0 bg-yellow-400 blur-2xl opacity-30 group-hover:opacity-50 transition-opacity rounded-2xl"></div>
            <WrappedImage
              src="/old_balance.png"
              alt="OLD BALANCE"
              className="h-64 md:h-80 w-auto relative z-10 rounded-2xl border-4 border-yellow-400/50 group-hover:border-yellow-400 transition-all shadow-2xl"
              style={{ maxHeight: '400px' }}
              maxHeight="400px"
            />
          </div>
          <div className="text-center mb-2">
            <div className="inline-block bg-yellow-500 text-black px-4 py-2 rounded-full text-xs md:text-sm font-bold animate-pulse">
              Click for 32% off OB Merch
            </div>
          </div>
          <p className="text-xs md:text-sm text-center text-yellow-300/80 mb-3 md:mb-4">
            {wrappedCopy.cards.oldBalance.sponsored}
          </p>
          {!isComplete && (
            <div className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-yellow-400 mb-2">
                {timeRemaining}
              </div>
              <p className="text-sm md:text-base text-yellow-300">Please wait...</p>
            </div>
          )}
        </div>
      </WrappedCard>
    </a>
  );
};

